export { default } from "ember-stargate/services/-portal";
